module.exports = __webpack_public_path__ + "img/dashboard-light.a1a54e3e.svg";